// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReferralPersonalCode-module-wrapper-1rLxJ{margin-top:50px}@media(min-width: 960px){.ReferralPersonalCode-module-wrapper-1rLxJ{max-width:940px}}.ReferralPersonalCode-module-dashboardStyles-1bbYm{margin-top:24px;max-width:90%}@media(min-width: 960px){.ReferralPersonalCode-module-dashboardStyles-1bbYm{max-width:100%}}@media(min-width: 1280px){.ReferralPersonalCode-module-withImageStyles-3_0YP{max-width:1260px}}.ReferralPersonalCode-module-builderStyle-yrWgG{width:100%;margin-block:0}", ""]);
// Exports
exports.locals = {
	"wrapper": "ReferralPersonalCode-module-wrapper-1rLxJ",
	"dashboardStyles": "ReferralPersonalCode-module-dashboardStyles-1bbYm",
	"withImageStyles": "ReferralPersonalCode-module-withImageStyles-3_0YP",
	"builderStyle": "ReferralPersonalCode-module-builderStyle-yrWgG"
};
module.exports = exports;
